import { ChildrenDto } from "./children.dto";

export class CardInfoDto {
   /*
   *
   */
    constructor(
      public id?:  number,
      public displaySorting?: number,
      public visible?: boolean,
      public active?: boolean,
      public creationDate?: string,
      public updateDate?: string,
      public parentIdCard?: number,
      public photo?: string,
      public title?: string,
      public type?: string,
      public children?: ChildrenDto[]
    ){}
    
}